import { render } from "./DownloadIcon.vue?vue&type=template&id=59d77b56"
import script from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadIcon.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Common/Svg/DownloadIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "59d77b56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('59d77b56', __exports__)) {
    api.reload('59d77b56', __exports__)
  }
  
  module.hot.accept("./DownloadIcon.vue?vue&type=template&id=59d77b56", () => {
    api.rerender('59d77b56', render)
  })

}


export default __exports__